import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { UserRequestSchema } from '../../generic/user-request/user-request-schema';

export class UserRequestUpdateUserSchema extends UserRequestSchema {
  public static readonly email = 'email';

  public static readonly password = 'password';

  public static readonly userId = 'userId';

  public static readonly isDisabled = 'isDisabled';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static Defaults = class extends UserRequestSchema.Defaults {
    public static readonly email = undefined;

    public static readonly password = undefined;

    public static readonly userId = undefined;

    public static readonly isDisabled = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[UserRequestUpdateUserSchema.email] = SchemaField.string(
      UserRequestUpdateUserSchema.Defaults.email,
    ).optional();

    parameters[UserRequestUpdateUserSchema.password] = SchemaField.string(
      UserRequestUpdateUserSchema.Defaults.password,
    ).optional();

    parameters[UserRequestUpdateUserSchema.userId] = SchemaField.userId(
      UserRequestUpdateUserSchema.Defaults.userId,
    ).required();

    parameters[UserRequestUpdateUserSchema.isDisabled] = SchemaField.boolean(
      UserRequestUpdateUserSchema.Defaults.isDisabled,
    ).optional();

    return parameters;
  }
}
